import { computed } from "vue";
import type { FilteredProductItem } from "@nwt/norce-pwa/dist/runtime/types/api/searchAndFilter/filters";
import type {
	ProductItem,
	ParametricListValue
} from "@nwt/norce-pwa/dist/runtime/types/api/product/product";

interface UseProductQuickBuyParams {
	product: Partial<FilteredProductItem> | ProductItem | undefined;
	variants?: FilteredProductItem[];
	allParametrics?: ParametricListValue[];
	showVariants?: boolean;
}

export function useProductQuickBuy({
	product,
	variants,
	allParametrics,
	showVariants = false
}: UseProductQuickBuyParams) {
	const isOutOfStock = computed(() => {
		if (!variants?.length) {
			return (
				(product?.OnHand?.Value ?? 0) + (product?.OnHandStore?.Value ?? 0) === 0
			);
		}
		return variants.every(
			(v) => (v.OnHand?.Value ?? 0) === 0 && (v.OnHandStore?.Value ?? 0) === 0
		);
	});

	const isModal = computed(() => (variants?.length ?? 0) > 1);

	const canQuickBuy = computed(
		() =>
			showVariants &&
			product?.IsBuyable !== false &&
			(allParametrics?.length ?? 0) > 0 &&
			!isOutOfStock.value
	);

	return {
		isModal,
		canQuickBuy
	};
}
